import OlMap from '@m1/ol-map';
import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import { toLonLat } from 'ol/proj';
import React, { useRef } from 'react';
import { useDispatch, useStore } from 'react-redux';

import Fences from './Fences';
import GuideMissions from './GuideMissions';
import GuideRobots from './GuideRobots';
import styles from './index.module.scss';
import Markers from './Markers';
import Path from './Path';
import Shoots from './Shoots';
import Survey from './Survey';

import actions from '@/actions';
import Crosshair from '@/components/ui/Crosshair';
import useMapCenterOnDimensionChange from '@/hooks/useMapCenterOnDimensionChange';

const cx = classNames.bind(styles);

const Map = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const map = useRef();
  const mapRef = useRef();

  useMapCenterOnDimensionChange();

  useMountEffect(() => {
    // redux-persist 활용한 최종 center 및 zoom 적용
    const { center, zoom } = store.getState().map;
    map.current = OlMap.init(mapRef.current, { center, zoom });

    // 지도 이동 중일 시
    map.current.getView().on('change:center', () => {
      const { lat, lng } = OlMap.getCenter();
      dispatch(actions.map.setCenter(lat, lng));
    });

    // 지도 이동 또는 줌 완료 시
    map.current.on('moveend', () => {
      const { lat, lng } = OlMap.getCenter();
      const zoom = map.current.getView().getZoom();
      dispatch(actions.map.setPositionWithZoom(lat, lng, zoom));
    });

    // 마우스 포인터 이동 시
    map.current.on('pointermove', (e) => {
      const [lng, lat] = toLonLat(e.coordinate);
      dispatch(actions.map.setPointer(lat, lng));
    });
  });

  return (
    <div className={cx('container')}>
      <div ref={mapRef} className={cx('map')} />
      <Path />
      <Fences />
      <GuideMissions />
      <GuideRobots />
      <Shoots />
      <Markers />
      <Survey />
      <Crosshair />
    </div>
  );
};

export default Map;
